import React from "react";

const ThemeProvider = React.createContext("light");

export default ThemeProvider;
